<template>
  <div>
    <div id="content" class="pageContentBox">
      <!-- 头部 -->
      <div class="header">
        <div class="logo">
<img src="https://zyanjing.oss-cn-hangzhou.aliyuncs.com/d6d0f500-6c34-45e6-b206-b87c368e4469/apiset/logimg/d6d0f500-6c34-45e6-b206-b87c368e4469.png?v=01c0ac90-4bfc-49c0-be77-08f3467c58f1">
        </div>
        <h2>注册向导</h2>
      </div>
      <!-- end -->
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps :active="active" align-center finish-status="success">
          <el-step title="公司信息"></el-step>
          <el-step title="门店信息"></el-step>
          <el-step title="人员维护"></el-step>
          <el-step title="经营品牌"></el-step>
          <el-step title="镜架库存"></el-step>
        </el-steps>
      </div>
      <!-- end -->
      <div class="line"></div>
      <div class="main-form-box">
        <div class="viewBox">
          <CompanyInfo :ref="'childCompRef'+active" v-if="active==0"></CompanyInfo>
          <ShopInfo :ref="'childCompRef'+active" v-if="active==1"></ShopInfo>
          <StaffMaintain :ref="'childCompRef'+active" v-if="active==2"></StaffMaintain>
          <BrandManage :ref="'childCompRef'+active" v-if="active==3"></BrandManage>
          <FrameStock :ref="'childCompRef'+active" v-if="active==4"></FrameStock>
        </div>
      </div>
    </div>
    <div class="stepBtnBox">
      <el-button :disabled="active==0" @click="prevStep()" :loading="loading">上一步</el-button>
      <el-button type="primary" v-if="active<4" @click="nextStep()" :loading="loading">下一步</el-button>
      <el-button type="success" v-else @click="finish()"  :loading="loading">完成</el-button>
    </div>
  </div>
</template>


<script>
import CompanyInfo from './childComp/CompanyInfo.vue'
import ShopInfo from './childComp/ShopInfo.vue'
import StaffMaintain from './childComp/StaffMaintain.vue'
import BrandManage from './childComp/BrandManage.vue'
import FrameStock from './childComp/FrameStock.vue'
import {startUse} from '@/api/sysmanage/register';

export default {
  components: {
    CompanyInfo,
    ShopInfo,
    StaffMaintain,
    BrandManage,
    FrameStock,
  },
  data() {
    return {
      active: 0,
      loading:false,
    }
  },
  methods: {
    prevStep() {
      let tempRef = this.$refs['childCompRef' + this.active];
      if (tempRef.prevFn) {
        tempRef.prevFn()
      }
      this.active -= 1;
    },
    nextStep() {
      // this.active += 1;
      let tempRef = this.$refs['childCompRef' + this.active];
      if (tempRef.finishFn) {
        this.loading = true;
        tempRef.finishFn((result) => {
          this.loading = false;
          if (result)
            this.active += 1;
        })
      } else {
        this.active += 1;
      }
    },
    finish() {//注册完成导向到正式使用页面
      this.$confirm('系统将正式启用，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        startUse().then(response => {
          localStorage.setItem("hpapi_tokenModel", JSON.stringify(response.data.tokenmodel))
          localStorage.setItem("hpapi_userInfoModel", JSON.stringify(response.data.userinfomodel))
          var hrefroute=localStorage.getItem("hrefroute");
          localStorage.removeItem("hrefroute");
          window.location.href = hrefroute;
        })
      })
    },
  },
  mounted() {//第一次加载，取公司信息
    var tokenModel = JSON.parse(localStorage.getItem("hpapi_tokenModel"));
    // if (tokenModel.regist != 'new') {
    //   localStorage.removeItem("appguid");
    //   localStorage.removeItem("tenantid");
    //   localStorage.removeItem("hpapi_token");
    //   localStorage.removeItem("hpapi_tokenModel");
    //   localStorage.removeItem("hpapi_userInfoModel");
    //   this.$message.error('系统尚未正式启用，请先初始化数据!')
    //   this.$router.push("/login");
    // }
  },
}
</script>

<style scoped>
  @import '../../static/css/clear.css';
  @import '../../static/css/index.css';

  .pageContentBox .header {
    width: 100%;
    height: 60px;
    background-color: #3e96f7;
    position: relative;
  }
  .pageContentBox .header .logo{
    position: absolute;
    line-height: 60px;
    left: 100px;
  }
  .pageContentBox .header h2{
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #fff;
    font-size: 24px;
    font-weight: 500;
  }

  .pageContentBox .stepBox {
    padding: 40px 0;
    height: 45px;
  }

  .pageContentBox .line {
    width: 100%;
    height: 1px;
    background-color: #ebebeb;
  }

  .pageContentBox .main-form-box {
    height: calc(100vh - 285px);
    overflow: auto;
  }

  .pageContentBox .main-form-box .viewBox {
    width: 1200px;
    margin: 10px auto 20px;
  }

  .stepBtnBox {
    position: fixed;
    background: #fff;
    width: 100%;
    bottom: 0;
    z-index: 1000;
    height: 100px;
    -webkit-box-shadow: 0 2px 8px 0 rgb(0 0 0);
    box-shadow: 0 2px 8px 0 rgb(0 0 0);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .stepBtnBox button{
    height: 52px;
    line-height: 52px;
    width: 240px;
    font-size: 18px;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Register.vue